export default __webpack_public_path__ + "static/media/sliderMobile_2.3465ae39.jpg";